<template>
  <div id="app" ref="printMap">
    <div class="controlButton">
      <div>
        <!-- button that refreshes page -->
        <button data-html2canvas-ignore="true" class="resetbtn" v-on:click="refreshpage" value="">
          Reset
        </button>
        <!-- button that refreshes page -->
      </div>

      <!-- toggle that turns on property lines TODO: update api key in index.html -->
      <div data-html2canvas-ignore="true" v-if="showPropertyLines" id="propertyLines"
        class="propertyLinesToggleWrapper">
        <label class="switch propertyLinesToggle">
          <input type="checkbox" />
          <span v-on:click="propertyLinesToggle" class="slider round"></span>
        </label>
        <p class="propertyLinesToggleLabel">Blank Screen</p>
      </div>
      <!-- toggle that turns on property lines TODO: update api key in index.html -->
    </div>

    <Login v-if="dbLoading" class="login" v-bind:adminUserData="adminUserData" v-on:userEmail="userEmail"
      v-on:adminid="adminid" v-bind:userData="userData" />

    <!-- These are here to prevent any stray clicks on the map before it is ready START -->
    <div v-if="blocker" class="blocker"></div>
    <div v-if="blocker2" class="blocker2"></div>
    <!-- These are here to prevent any stray clicks on the map before it is ready END -->

    <googleMap v-if="dbLoading" v-on:blockerGone="blockerGone" v-on:addUsertoUsers="addUsertoUsers"
      v-on:didNotFallOff="didNotFallOff" v-on:showPropertyLinesToggle="showPropertyLinesToggle"
      v-on:finishFenceSwitch="finishFenceSwitch" v-bind:chargeMd="chargeMd" v-bind:adminUserData="adminUserData"
      v-bind:toEmail="toEmail" v-bind:companyLogo="companyLogo" v-bind:reset="reset" v-bind:showLocate="showLocate"
      v-bind:userData="userData" v-bind:laborForGate="laborForGate" v-bind:extraPanelData="extraPanelData"
      v-bind:removalDbSource="removalDbSource" v-bind:fenceCapStyle="fenceCapStyle" v-bind:fencelengths="fencelengths"
      v-bind:fencePricing="fencePricing" v-bind:adminId="adminId" v-bind:propertyLinesValue="propertyLinesValue" />
  </div>
</template>
<script src="https://code.jquery.com/jquery-3.4.1.js"></script>

<script>
import axios from "axios";
// static pricing sheet in /assets as hard copy backup
import json from "./assets/pricing.json";
// static pricing sheet in /assets as hard copy backup
import googleMap from "./components/googleMap.vue";
import Login from "./components/Login.vue";
import { db } from "./assets/db.js";
import { seter } from "./assets/set.js";
import {
  doc,
  getDoc,
  query,
  collection,
  where,
  onSnapshot,
  getDocs,
} from "firebase/firestore";

export default {
  name: "App",
  components: {
    googleMap,
    Login,
  },
  data() {
    return {
      // Pricing starts as json hard copy backup just in case the axios has an error
      userId: null,
      docId: null,
      toEmail: null,
      fencePricing: null,
      laborForGate: null,
      fenceCapStyle: null,
      extraPanelData: null,
      dbLoading: false,
      showLocate: true,
      chargeMd: null,
      adminUserData: null,
      companyLogo: null,
      removalDbSource: null,
      reset: false,
      userData: [
        {
          id: 0,
          firstName: "",
          lastName: "",
          phoneNumber: "",
          emailAddress: "",
          homeAddress: "",
          utm: "",
          gclid: "",
          jnid: "",
        },
      ],
      adminId: 0,
      fencelengths: [
        {
          fencelengths: 0,
        },
      ],
      propertyLinesValue: false,
      showPropertyLines: false,
      blocker: true,
      blocker2: false,
    };
  },
  async created() {
    this.userId = null;

    let uri = window.location.href.split("?");

    if (uri.length == 2) {
      let vars = uri[1].split("&");
      let getVars = {};
      let tmp = "";

      vars.forEach(function (v) {
        tmp = v.split("=");
        if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      });
      this.userId = getVars.partnerCode;
      // do
    }

    this.fencePricing = null;
    this.laborForGate = null;
    this.fenceCapStyle = null;
    this.companyLogo = null;
    this.removalDbSource = null;
    this.extraPanelData = null;

    const docRef = doc(db, "products", this.userId);
    const chargeRef = doc(db, "users", this.userId);
    const docSnap = await getDoc(docRef);
    const chargeSnap = await getDoc(chargeRef);

    if (chargeSnap.exists()) {
      this.companyLogo = chargeSnap.data()["avatar"];
      this.toEmail = chargeSnap.data()["mail"];
      this.adminUserData = chargeSnap.data();
    }
    if (docSnap.exists()) {
      this.allData = docSnap.data();
      this.fencePricing = docSnap.data()["setupYourStyles"];
      this.laborForGate = docSnap.data()["laborForGate"];
      this.fenceCapStyle = docSnap.data()["fenceCapStyle"];
      this.removalDbSource = docSnap.data()["removalForCategoryPerFoot"];
      this.extraPanelData = docSnap.data()["extraPanelData"];
      this.dbLoading = true;
    } else {
      this.dbLoading = false;
    }
    // gclid capture START
    // This grabs the google gclid off of the end of the url if the user comes form an ad
    var currentUrl = document.location.href;
    var gclidIndex = currentUrl.indexOf("gclid");
    var gclidEnd = currentUrl.indexOf("&", gclidIndex);
    var urlLength = currentUrl.length;
    var gclid;
    if (gclidEnd == "-1" && gclidIndex != "-1") {
      gclid = currentUrl.slice(gclidIndex + 6, urlLength);
    } else if (gclidEnd != "-1" && gclidIndex != "-1") {
      gclid = currentUrl.slice(gclidIndex + 6, gclidEnd);
    } else {
      gclid = "";
    }
    this.userData[0].gclid = gclid;
    // gclid capture END
    // utm capture START
    // Grabs the utm just like the gclid above
    var currentUrl = document.location.href;
    var utmIndex = currentUrl.indexOf("utm_term=");
    var utmEnd = currentUrl.indexOf("&", utmIndex);
    var urlLength = currentUrl.length;
    var utm;
    if (utmEnd == "-1" && utmIndex != "-1") {
      utm = currentUrl.slice(utmIndex + 9, urlLength);
    } else if (utmEnd != "-1" && utmIndex != "-1") {
      utm = currentUrl.slice(utmIndex + 9, utmEnd);
    } else {
      utm = "";
    }
    this.userData[0].utm = utm;
    // utm capture END
  },
  computed: {
    firstnameFix() {
      return this.userData[0].firstName;
    },
    lastnameFix() {
      return this.userData[0].lastName;
    },
  },
  watch: {
    firstnameFix() {
      this.userData[0].firstName = this.firstnameFix.replace(/\s/g, "");
    },
    lastnameFix() {
      this.userData[0].lastName = this.lastnameFix.replace(/\s/g, "");
    },
  },
  mounted() {},
  methods: {
    adminid() {
      this.adminId = 1;
    },
    refreshpage() {
      // location.reload(true);
      this.reset = !this.reset;
      // reset blank screen
      this.propertyLinesValue = false;
      // remove fence drawed
      $(`#lengthSetter`).children().remove();
      $(`#cornerSetter`).children().remove();
      $(`#lineSetter`).children().remove();
    },
    async userEmail() {},

    // This takes the user information and adds it to Jobnimbus CRM && Firebase if they are a guest
    addUsertoUsers() {
      var self = this;
      var admin;
      if (this.adminId == 1) {
        admin = "Yes";
      } else {
        admin = "No";
      }
      var dataTime = new Date();
      // Sending the user to Firebase START

      // Check if the user is already in Jobnimbus END
    },
    //
    sendUserToJobnimbus() {
      var self = this;
      var dataTime = new Date();
      var settings;
    },
    // catching if the user finishes the flow and gets an estimate
    didNotFallOff() {
      var admin;
      if (this.adminId == 1) {
        admin = "Yes";
      } else {
        admin = "No";
      }
      var dataTime = new Date();
      db.collection("Users")
        .doc(
          this.userData[0].firstName +
            "-" +
            this.userData[0].lastName +
            "-" +
            this.userData[0].phoneNumber
        )
        .set({
          first: this.userData[0].firstName,
          last: this.userData[0].lastName,
          phone: this.userData[0].phoneNumber,
          email: this.userData[0].emailAddress,
          address: this.userData[0].homeAddress,
          time: dataTime,
          falloff: false,
          Admin: admin,
          estimate: null,
        });
      var self = this;
    },
    propertyLinesToggle() {
      this.propertyLinesValue = !this.propertyLinesValue;
    },
    showPropertyLinesToggle() {
      this.showPropertyLines = true;
    },
    blockerGone() {
      this.blocker = !this.blocker;
    },
    finishFenceSwitch() {
      this.blocker2 = true;
    },
  },
};
</script>

<style>
#app {}

* {
  margin: 0px !important;
  padding: 0px !important;
}

*:focus {
  outline: none !important;
}

p {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
  /* Standard */
}

::-webkit-input-placeholder {
  /* Edge */
  color: grey !important;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: grey !important;
}

::placeholder {
  color: grey !important;
}

input[type="button"],
button,
input[type="submit"] {
  font-family: sofia-pro, sans-serif;
  font-size: 16px !important;
  margin-top: 20px !important;
  width: auto;
  height: auto;
  border: none;
  border-radius: 5px;
  background-color: #2572bf;
  color: white;
  padding: 8px 40px 10px 40px !important;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

input[type="button"]:hover,
button:hover,
nput[type="submit"]:hover {
  cursor: pointer;
  background-color: #297bce;
}

#app {
  position: fixed;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  width: 100vw;
  height: 100vh;
}

h4 {
  color: #2c3e50 !important;
  letter-spacing: 0px !important;
}

.formdone {
  opacity: 0 !important;
}

.formadd {
  opacity: 1 !important;
}

.formdone2 {
  z-index: -10 !important;
}

.loginBox {
  overflow: hidden;
}

.goaway {
  display: none;
}

.resetbtn {
  position: absolute;
  left: 20px;
  z-index: 20;
  font-size: 12px !important;
  padding: 4px 10px 5px 10px !important;
  border-radius: 1px;
}

.login {
  z-index: 100 !important;
}

/* The switch - the box around the slider */

.propertyLinesToggleWrapper {
  position: absolute;
  top: 21px;
  left: 100px;
  background-color: #ffffff !important;
  width: 150px;
  height: 28px;
  display: block;
  z-index: 2;
  border-radius: 20px;
}

.propertyLinesToggleLabel {
  position: relative;
  z-index: 99;
  font-size: 14px;
  left: 30px;
  text-align: left !important;
  top: 2px !important;
  padding: 2px 20px !important;
}

.switch {
  position: absolute;
  display: inline-block;
  width: 40px;
  height: 24px;
  z-index: 100;
  left: 2px;
  top: 2px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.blocker {
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.blocker2 {
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1;
}

.controlButton {
  display: flex;
}
</style>
